import Vue from 'vue';
import axios from 'axios';
import Vuex from 'vuex';

Vue.use(Vuex);

// 🔐 Inicializar Token
const token = window.localStorage.getItem('token');

if (token) {
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
}

export const SET_USER = 'SET_USER';
export const LOGOUT = 'LOGOUT';
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE';
export const SET_TOKEN = 'SET_TOKEN';

export default new Vuex.Store({
    state: {
        user: null,
        token: window.localStorage.getItem('token')
    },
    getters: {
        user: state => state.user,
        check: state => !!state.user,
        token: state => state.token
    },
    mutations: {
        SET_USER(state, { user }) {
            state.user = user;
        },
        LOGOUT(state) {
            state.user = null;
            state.token = null;
            window.localStorage.removeItem('token');
            window.sessionStorage.removeItem('valzum_last_auth_at');
            window.sessionStorage.removeItem('valzum_app_lock_unlocked_at');
            window.sessionStorage.removeItem('valzum_app_lock_left_at');
            window.sessionStorage.removeItem('valzum_idle_last_activity_at');
            window.sessionStorage.removeItem('valzum_staff_idle_locked');
            window.sessionStorage.removeItem('valzum_native_password_due');
            delete axios.defaults.headers.common['Authorization'];
        },
        FETCH_USER_FAILURE(state) {
            state.user = null;
            state.token = null;

            window.localStorage.removeItem('token');
            window.sessionStorage.removeItem('valzum_last_auth_at');
            window.sessionStorage.removeItem('valzum_app_lock_unlocked_at');
            window.sessionStorage.removeItem('valzum_app_lock_left_at');
            window.sessionStorage.removeItem('valzum_idle_last_activity_at');
            window.sessionStorage.removeItem('valzum_staff_idle_locked');
            window.sessionStorage.removeItem('valzum_native_password_due');
            delete axios.defaults.headers.common['Authorization'];
        },
        SET_TOKEN(state, { token }) {
            state.token = token;
            if (token) {
                window.localStorage.setItem('token', token);
                window.sessionStorage.setItem('valzum_last_auth_at', String(Date.now()));
                window.sessionStorage.setItem('valzum_idle_last_activity_at', String(Date.now()));
                window.sessionStorage.removeItem('valzum_staff_idle_locked');
                window.sessionStorage.removeItem('valzum_native_password_due');
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            } else {
                window.localStorage.removeItem('token');
                window.sessionStorage.removeItem('valzum_last_auth_at');
                window.sessionStorage.removeItem('valzum_app_lock_unlocked_at');
                window.sessionStorage.removeItem('valzum_app_lock_left_at');
                window.sessionStorage.removeItem('valzum_idle_last_activity_at');
                window.sessionStorage.removeItem('valzum_staff_idle_locked');
                window.sessionStorage.removeItem('valzum_native_password_due');
                delete axios.defaults.headers.common['Authorization'];
            }
        }
    },
    actions: {
        // 🔐 Guardar Token
        saveToken({ commit }, payload) {
            commit(SET_TOKEN, payload);
        },

        // 👤 Obtener Usuario
        async fetchUser({ commit }) {
            try {
                const { data } = await axios.get('/api/profile');
                commit(SET_USER, data);
            } catch (e) {
                commit(FETCH_USER_FAILURE);
                throw e; // 🔥 Importante para router
            }
        },

        // 👤 Set manual
        setUser({ commit }, payload) {
            commit(SET_USER, payload);
        },

        // 🚪 Logout
        async logout({ commit }) {
            try {
                await axios.post('/api/logout');
            } catch (e) {}

            commit(LOGOUT);
        },

        // 💣 Forzar logout local
        destroy({ commit }) {
            commit(LOGOUT);
        },

        // 🌐 OAuth
        async fetchOauthUrl(ctx, { provider }) {
            const { data } = await axios.post('/api/auth/' + provider);
            return data.url;
        }
    }
});
